import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';


import Navbar from "../../components/Navbar/Navbar";
import classes from './Products.module.css';

import Foot from "../../components/Foot/Foot";
import AllProducts from '../../components/Allproducts/AllProducts';

function Products(props){
    return(
        <div className={classes.container}>
        <Navbar/>
        <div className={classes.box}> 
        <div className={classes.all}>
          <h4>ALL OUR PRODUCTS</h4>
          <hr></hr>
        </div>
       
      
        <AllProducts getProduct={props.getProduct}/>
      

        </div>
        <Foot/>

       
       
                

        
      </div>
    )
}


export default Products;   